import React, { Component } from 'react';
import {
  Button, Dialog, DialogActions, DialogContent, DialogContentText,
  DialogTitle, Paper, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, TextField,Typography,Box,Collapse,
  IconButton,InputAdornment,
  Alert,FormControl,MenuItem,Select}
  from '@mui/material';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import PersonIcon from '@mui/icons-material/Person';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
//import axios from 'axios';
import axiosInstance from "./axiosConfig";
import TablePagination from '@mui/material/TablePagination';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import { Navigate  } from 'react-router-dom';
import Serverurl from './Apiurl';
import searchIcon from './images/SEARCH.png';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

export default class Customermanagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      CustData: [],
      totalItems: 0,searchText: "",
searchStatus: "",
      page: 0,
      rowsPerPage: 5,
      itemsPerPageOptions: [5, 10, 20],
    };

    this.customerDialogRef = React.createRef();
  }

  componentDidMount () {
	  document.title = "Prep for Sale- Customer Management";
		if(localStorage.getItem("DCuserid")==null)
		  {
		   this.setState({
            logredirect: true,
			pagename:'/'
          })
		  }
	  this.fetchCustomers();
  }

  /*fetchCustomers = () => {
    axios
      .get(`${Serverurl}customer/getall?onlyrole4=1&page=${this.state.page}&limit=${this.state.rowsPerPage}`)
      .then((res) => {
        const { data, totalItems } = res.data;
        this.setState({ CustData: data, totalItems });
      });
  };*/
  fetchCustomers = () => {
  const { page } = this.state;

  const params = {
    page,
    limit: this.state.rowsPerPage,
    onlyrole4: 1,  
    ...(this.state.searchText && { search: this.state.searchText }),
    ...(this.state.searchStatus !== "" && { status: this.state.searchStatus }),
  };
  axiosInstance
    .get(`${Serverurl}customer/getall`, { params })
    .then((res) => {
      const { data, totalItems } = res.data;
      this.setState({ CustData: data, totalItems });
    });
};


  handleDelete = (cu_id) => {
    confirmAlert({
      title: 'Confirm Delete',
      message: 'Are you sure you want to delete this customer?',
      buttons: [
        {
          label: 'Yes',
          onClick: () =>
            axiosInstance.delete(`${Serverurl}customer/customerdelete/${cu_id}`).then(() => this.fetchCustomers()),
        },
        { label: 'No' },
      ],
    });
  };

 toggleActiveStatus = (cu_id, newStatus) => {
    const actionText = newStatus === 1 ? 'Block' : 'Unblock';

    confirmAlert({
      title: 'Confirm' ,
      message: `Are you sure you want to ${actionText} this customer?`,
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            axiosInstance.put(`${Serverurl}customer/customeractive/${cu_id}`, { cu_isactive: newStatus })
              .then(() => this.fetchCustomers())
          }
        },
        { label: 'No' }
      ]
    });
  };

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage }, this.fetchCustomers);
  };

  handleChangeRowsPerPage = (event) => {
    const newRows = parseInt(event.target.value, 10);
    this.setState({ rowsPerPage: newRows, page: 0 }, this.fetchCustomers);
  };

  CustomerAddbox = (customer = null) => {
    this.customerDialogRef.current?.handleClickOpen(customer);
  };

  render() {
	  if (this.state.logredirect === true) {
      return <Navigate to={this.state.pagename} />
    } 
    return (
      <>
	  	  <div className="maincontentDiv">
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
          
		  <Typography className="contentHeading" variant="h5">Manage Customers</Typography>

          <Button
		  style={{
    marginRight: '20px',
    marginTop: '15px'
}}
		  size="small"
            variant="contained"
            className="frmPrimarybtn"
            onClick={() => this.CustomerAddbox(null)}
            startIcon={<AddIcon />}
          >
            Add
          </Button>
        </Box>
<Box
  sx={{
    display: "flex",
    gap: 2,
    mb: 3,
    flexWrap: "wrap",
    alignItems: "center"
  }}
>
  <Box className="contentSearch" sx={{ display: "flex", flexDirection: "column", width: "230px" }}>
    <Typography  variant="body1">Name / Email / Mobile</Typography>
    <TextField
      size="small"
      placeholder="Search"
      value={this.state.searchText}
      onChange={(e) => this.setState({ searchText: e.target.value })}
	  InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <img
            src={searchIcon} 
            alt="Search"           
          />
        </InputAdornment>
      ),
    }}
  />
  </Box>

  <Box sx={{ display: "flex", flexDirection: "column", width: "230px"}}>
  <Typography variant="body1">Status</Typography>

  <FormControl fullWidth size="small">
    <Select
	displayEmpty
      value={this.state.searchStatus}
      onChange={(e) => this.setState({ searchStatus: e.target.value })}
    >
      <MenuItem value="">All</MenuItem>
      <MenuItem value="0">Active</MenuItem>
      <MenuItem value="1">Inactive</MenuItem>
    </Select>
  </FormControl>
</Box>

  <Button
  size="small"
    variant="contained"
    className="frmPrimarybtn"  
    onClick={() => this.setState({ page: 0 }, this.fetchCustomers)}
sx={{marginTop:3}}	
  >
    Search
  </Button>
</Box>
        <Customerdialog ref={this.customerDialogRef} onSuccess={this.fetchCustomers} />

        <TableContainer component={Paper}>
         <Table aria-label="customer table">
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Mobile</TableCell>
                <TableCell>Status</TableCell>
              </TableRow>
            </TableHead>
           <TableBody>
  {Array.isArray(this.state.CustData) && this.state.CustData.length > 0 ? (
    this.state.CustData.map((customer, index) => (
      <TableRow key={index}>
        <TableCell>{customer.cu_name}</TableCell>
        <TableCell>{customer.cu_emailid}</TableCell>
        <TableCell>{customer.cu_phonenumber}</TableCell>

        <TableCell>
          {customer.cu_isactive === 1 ? (
            <Button
			size="small"
              variant="contained"
              className="frmPrimarybtn"
              onClick={() => this.toggleActiveStatus(customer.cu_id, 0)}
			                endIcon={<PersonOffIcon />}

            >
              Unblock
            </Button>
          ) : (
            <Button
			size="small"
              variant="contained"
              className="frmPrimarybtn"
              onClick={() => this.toggleActiveStatus(customer.cu_id, 1)}
			                endIcon={<PersonIcon />}
            >
              Block
            </Button>
          )}
        </TableCell>

        <TableCell>
          <Button
		  size="small"
            variant="contained"
            className="frmPrimarybtn"
            onClick={() => this.CustomerAddbox(customer)}
            endIcon={<EditIcon />}
            sx={{ mr: 1 }}
          >
            Edit
          </Button>

          <Button
		  size="small"
            variant="contained"
            className="frmSecondarybtn"
            onClick={() => this.handleDelete(customer.cu_id)}
            endIcon={<DeleteIcon />}
          >
            Delete
          </Button>
        </TableCell>
      </TableRow>
    ))
  ) : (
    <TableRow>
      <TableCell colSpan={5} align="center">
        No customer records found.
      </TableCell>
    </TableRow>
  )}
</TableBody>


          </Table>

          <TablePagination
            component="div"
            count={this.state.totalItems}
            page={this.state.page}
            rowsPerPage={this.state.rowsPerPage}
            onPageChange={this.handleChangePage}
            onRowsPerPageChange={this.handleChangeRowsPerPage}
            rowsPerPageOptions={this.state.itemsPerPageOptions}
          />
        </TableContainer></div>
      </>
    );
  }
}



 class Customerdialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cu_id: '',
      cu_name: '',showPassword: false,
      cu_emailid: '',
      cu_phonenumber: '',
      cu_password: '',

      isEditing: false,
      open: false,

      validationErrors: {},
      errormessage: '',
      erropen: false,
    };
  }

  handleClickOpen = (customer = null) => {
    if (customer) {
      this.setState({
        cu_id: customer.cu_id,
        cu_name: customer.cu_name,
        cu_emailid: customer.cu_emailid,
        cu_phonenumber: customer.cu_phonenumber,
        cu_password: '',

        isEditing: true,
        open: true,
        erropen: false,
        errormessage: '',
      });
    } else {
      this.setState({
        cu_id: null,
        cu_name: '',
        cu_emailid: '',
        cu_phonenumber: '',
        cu_password: '',

        isEditing: false,
        open: true,
        erropen: false,
        errormessage: '',
      });
    }
  };

  handleCloseDialog = () => {
    this.setState({
      cu_id: null,
      cu_name: '',
      cu_emailid: '',
      cu_phonenumber: '',
      cu_password: '',

      isEditing: false,
      open: false,
      validationErrors: {},
      erropen: false,
      errormessage: '',
    });
  };

  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  validateForm = () => {
  const errors = {};

  if (!this.state.cu_name.trim()) {
    errors.cu_name = "Name is required";
  }

  
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!this.state.cu_emailid.trim()) {
    errors.cu_emailid = "Email is required";
  } else if (!emailRegex.test(this.state.cu_emailid)) {
    errors.cu_emailid = "Invalid email address";
  }

 if (!String(this.state.cu_phonenumber).trim()) {
      errors.cu_phonenumber = 'Phone number is required';
    } else if (!/^\d{10}$/.test(this.state.cu_phonenumber)) {
      errors.cu_phonenumber = 'Phone number must be exactly 10 digits';
    }
 
  if (!this.state.isEditing && !this.state.cu_password.trim()) {
    errors.cu_password = "Password is required";
  }

   if (Object.keys(errors).length > 0) {
      const firstError = errors.cu_name || errors.cu_emailid ||errors.cu_phonenumber ||errors.cu_password ||errors.cu_role ||errors.cu_firstweekoff ||errors.cu_secondweekoff ;
      this.setState({
        validationErrors: errors,
        errormessage: firstError,
        erropen: true,
      });
      return false;
    }

    this.setState({ validationErrors: {}, errormessage: '', open: false });
    return true;
};

handleSubmit = () => {
  if (!this.validateForm()) return;

  const payload = {
    cu_name: this.state.cu_name,
    cu_emailid: this.state.cu_emailid,
    cu_phonenumber: this.state.cu_phonenumber,
    cu_role: 4,
  };

  if (this.state.cu_password.trim() !== "") {
    payload.cu_password = this.state.cu_password;
  }

  let request;
  if (this.state.isEditing) {
    request = axiosInstance.put(`${Serverurl}customer/customerupdate/${this.state.cu_id}`, payload);
  } else {
    request = axiosInstance.post(`${Serverurl}customer/customerinsert`, payload);
  }

  request
    .then(() => {
      this.props.onSuccess();
      this.handleCloseDialog();
    })
    .catch((err) => {
      const backendError =
        err.response?.data?.error ||
        err.response?.data?.message ||
        "Error occurred";

      this.setState({
        errormessage: backendError,
        erropen: true,
        open: true,  
      });
    });
};

togglePasswordVisibility = () => {
  this.setState((prevState) => ({
    showPassword: !prevState.showPassword
  }));
};

  render() {
    return (
      <Dialog open={this.state.open} onClose={this.handleCloseDialog} maxWidth="sm" fullWidth>
        <DialogTitle>
          {this.state.isEditing ? "Customer" : "Customer"}
        </DialogTitle>

        <DialogContent>
 <Collapse in={this.state.erropen}>
            <Alert severity="error" action={<IconButton onClick={() => this.setState({ erropen: false })}><CloseIcon /></IconButton>}>
              {this.state.errormessage}
            </Alert>
          </Collapse>

          <p>Name<span className="validation"> * </span></p>
<TextField
size="small"
  name="cu_name"
  placeholder="Enter name"
  fullWidth
  margin="normal"
  inputProps={{ maxLength: 150 }}
  value={this.state.cu_name}
  onChange={this.handleInputChange}
  inputProps={{ 'aria-labelledby': 'label-cu_name' }}
/>

			<p>Email<span className="validation"> * </span></p>
            <TextField
			size="small"
              name="cu_emailid"
               placeholder="Enter email"
			   inputProps={{ maxLength: 150 }}
              fullWidth
              margin="normal"
              value={this.state.cu_emailid}
              onChange={this.handleInputChange}
            />
			<p>Phone Number<span className="validation"> * </span>
			</p>
            <TextField
			size="small"
              name="cu_phonenumber"
             placeholder="Enter Phonenumber"
              fullWidth
              margin="normal"
              inputProps={{ maxLength: 11 }}
              value={this.state.cu_phonenumber}
              onChange={this.handleInputChange}
            />
           <p>Password<span className="validation"> * </span></p>
<TextField
  fullWidth
  size="small"
  type={this.state.showPassword ? "text" : "password"}
  name="cu_password"
  inputProps={{ maxLength: 60 }}
  value={this.state.cu_password}
  onChange={this.handleInputChange}
  autoComplete="new-password"
  InputProps={{
    endAdornment: (
      <InputAdornment position="end">
        <IconButton onClick={this.togglePasswordVisibility} size="small" edge="end">
          {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
        </IconButton>
      </InputAdornment>
    )
  }}
/>

        </DialogContent>

       <DialogActions sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button variant="contained" className="frmSecondarybtn" onClick={this.handleCloseDialog}>Cancel</Button>
          <Button variant="contained" className="frmPrimarybtn" onClick={this.handleSubmit}>Save</Button>
        </DialogActions>
      </Dialog>
    );
  }
}
